class Auth {
  static authenticateUser(token, user) {
    localStorage.setItem('token', token);
    Auth.setUser(user);
  }

  static isLocalStorageSupported() {
    try {
      const key = "__some_random_key_to_know_you_use_local_storage__";
      localStorage.setItem(key, key);
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  static isUserAuthenticated() {
    return Auth.getToken() !== null && Auth.getUser() !== null;
  }

  static isAccountConfirmed() {
    const { registration: { confirmed = false } = {} } = Auth.getUser() || {};
    return !!confirmed;
  }

  static deauthenticateUser() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  static getToken() {
    return localStorage.getItem('token');
  }

  static getUser() {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch (err) {
      return null;
    }
  }

  static setUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  static getAuthorizationHeader() {
    return `bearer ${Auth.getToken()}`;
  }
}

export default Auth;